<div class="sec-container">
  <h2>Инструкция по установке и уходу за QR-табличкой</h2>
  <div class="row mb-4">
    <div class="d-md-none d-sm-block">
      <img class="step-img" src="assets/sign-instruction-img.png" alt="" />
    </div>
    <div class="col-md-6 col-sm-12">
      <div class="step-title">1. Установка таблички</div>
      <div class="step-desc">
        QR-табличка изготовлена из высококачественной нержавеющей стали,
        устойчивой к погодным условиям. Для крепления можно использовать клей
        или монтажную ленту (акриловая, морозостойкая).
      </div>
      <div class="row single-step-section">
        <div class="col-12 step-item">
          <ul>
            <li>Обезжирьте поверхность памятника спиртом.</li>
            <li>
              Нанесите эпоксидный клей или надежный металлический адгезив.
            </li>
            <li>Плотно прижмите табличку на 1–2 минуты.</li>
            <li>Не подвергайте нагрузке 24 часа до полного высыхания.</li>
          </ul>
        </div>
      </div>
      <div class="row">
        <div class="col-12 step-item">
          <div class="step-title">2. Проверка QR-кода после установки</div>
          <ul>
            <li>
              Отсканируйте код смартфоном, чтобы убедиться, что он ведет на
              нужную страницу.
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-sm-12 d-none d-md-block">
      <img class="step-img" src="assets/sign-instruction-img.png" alt="" />
    </div>
  </div>

  <div class="row mb-4">
    <div class="col-md-6 col-sm-12">
      <div class="step-title">3. Уход за табличкой</div>
      <div class="row">
        <div class="col-md-6 col-sm-12 step-item">
          <div class="step-subtitle">Регулярная очистка:</div>
          <ul>
            <li>
              Протирайте табличку мягкой тканью или губкой с мыльным раствором.
            </li>
            <li>Не используйте абразивные средства и жесткие щетки.</li>
          </ul>
        </div>
        <div class="col-md-6 col-sm-12 step-item mobile-margin">
          <div class="step-subtitle">Защита от наледи и грязи:</div>
          <ul>
            <li>Зимой аккуратно удаляйте снег и лед пластиковым скребком.</li>
            <li>Избегайте ударов и царапин.</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-sm-12">
      <div class="step-title">4. Долговечность и гарантия</div>
      <ul>
        <li>
          прочная нержавеющая сталь защищает табличку от коррозии, но для
          продления срока службы избегайте контакта с агрессивными химикатами.
        </li>
        <li>
          При повреждении QR-кода (царапины, глубокие сколы) свяжитесь с нами
          для замены (платная услуга).
        </li>
      </ul>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <div class="step-notification">
        <div class="step-title">5. Важно!</div>
        <ul>
          <li>Раз в год проверяйте надежность фиксации.</li>
          <li>
            По истечении срока подписки (2 года), вам придет уведомление о
            продлении.
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
